import * as R from 'ramda';
import { AppState } from './appState';
import { Action } from 'redux';
import { ActionType } from './actionType';


/**
 * Reducer that tracks the user's activity for the logout timer
 */
export const raterInviteTimestampReducer = (state: AppState, action: Action<ActionType>): AppState => {
  if (action.type !== ActionType.SendInvitationsRequest) {
    return state;
  }

  return R.assoc('lastInviteRequest', new Date(), state);
};
